import { IotsUptimeLineChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { useLast30DaysHardwareIotsUptimeLineChart } from './use-last-30-days-hardware-iots-uptime-line-chart';

export interface Last30DaysHardwareIotsUptimeLineChartProps {
    accountId: string;
}

export const Last30DaysHardwareIotsUptimeLineChart = (props: Last30DaysHardwareIotsUptimeLineChartProps) => {
    const { data, isLoading, averageUptime } = useLast30DaysHardwareIotsUptimeLineChart(props);

    return (
        <StatisticsCard
            chartKey={IotsUptimeLineChart.definition.key}
            title={
                <FormattedMessage
                    id='platform.statistics.hardware.last-30-days-hardware-iots-uptime-line-chart.title'
                    description='Title of the hardware insights chart showing IoT uptime over the last 30 days'
                    defaultMessage='Uptime over time'
                />
            }
            subtitle={
                averageUptime === null ? undefined : (
                    <FormattedMessage
                        id='platform.statistics.hardware.last-30-days-hardware-iots-uptime-line-chart.subtitle'
                        description='Subtitle showing average IoT uptime percentage over the last 30 days'
                        defaultMessage='{value}% avg · last 30 days'
                        values={{ value: averageUptime }}
                    />
                )
            }
            isLoading={isLoading}
            hasData={!!data}>
            {data && (
                <div className='h-full min-h-0 w-full flex-1'>
                    <IotsUptimeLineChart
                        data={data}
                        minHeight={160}
                        showLabels='minimal'
                        tooltipShared
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
